import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormControl,
  MenuItem,
  Select,
  LinearProgress,
  InputLabel,
  Grid,
  Menu,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import {
  convertDate,
  convertYearMonthDateToMonthDateYear,
} from "../../utils/DateFormats";

export default function AdminUserManagement({ onBack }) {
  const [users, setUsers] = useState({
    roleId: "",
    userId: "",
    firstName: "",
    lastName: "",
    mobileNo: "",
    email: "",
    role: "",
    password: "",
    confirmPassword: "",
    status: "",
    gender: "",
    dob: "",
    aadharNo: "",
    panNo: "",
    profile: "",
    created_by: "",
  });

  const clearErrors = () => {
    setFirstNameError("");
    setMobileNoError("");
    setEmailError("");
    setRoleError("");
    setStatusError("");
    setGenderError("");
    setDobError();
    setAadharNoError("");
    setPanNoError("");
    setPasswordError("");
    setConfirmPasswordError("");
  };
  const initializeUsers = () => {
    setUsers({
      roleId: "",
      userId: "",
      firstName: "",
      lastName: "",
      mobileNo: "",
      email: "",
      role: "",
      password: "",
      confirmPassword: "",
      status: "",
      gender: "",
      dob: "",
      aadharNo: "",
      panNo: "",
      profile: "",
      created_by: "",
    });
  };
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const imageInputRef = useRef(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [roleName, setRoleName] = useState("");
  const [fromDate, setfromDate] = useState(new Date());
  const [toDate, settoDate] = useState(new Date());
  const [dob, setDob] = useState(new Date());
  const [password, setPassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [firstNameError, setFirstNameError] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [roleError, setRoleError] = useState("");
  const [statusError, setStatusError] = useState("");
  const [genderError, setGenderError] = useState("");
  const [dobError, setDobError] = useState("");
  const [aadharNoError, setAadharNoError] = useState("");
  const [panNoError, setPanNoError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const [roleData, setRolesData] = useState([]);
  const [selectedProfileFile, setSelectedProfileFile] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isEditMode, setEditMode] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const loginToken = useSelector((state) => state.user.logintoken);
  const userDetails = useSelector((state) => state.user.userdetails);
  const userId = userDetails ? userDetails["user_id"] : null;

  useEffect(() => {
    if (
      userDetails.role_name == "Admin" ||
      userDetails.role_name == "Superadmin"
    ) {
      fetchData();
    } else {
      fetchusersWithIdData();
    }
    fetchAllRolesData();
  }, []);

  //getAllUsers
  const {
    data: usersData,
    isLoading: isUsersLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllUsers", userId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: usersWithIdData,
    isLoading: isUsersWithIdDataLoading,
    error: usersWithIdError,
    fetchData: fetchusersWithIdData,
  } = useFetch(BASE_URL_TEST + urls("getAllUsersById", userId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: createUsersData,
    isLoading: createUsersLoading,
    error: createUsersError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createUsers"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateUsersData,
    isLoading: updateUsersLoading,
    error: updateUsersError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deleteUsersData,
    isLoading: deleteUsersLoading,
    error: deleteUsersError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  // Fetching roles data from the API using useFetch
  const {
    data: allRolesData,
    allRolesLoading,
    allRoleserror,
    fetchData: fetchAllRolesData,
  } = useFetch(BASE_URL_TEST + urls("getAllRoles"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  //All Roles data
  useEffect(() => {
    if (allRoleserror) {
    } else if (allRolesData && allRolesData.status == true) {
      setRolesData(allRolesData["data"]);
    }
  }, [allRolesData, allRoleserror]);

  useEffect(() => {
    if (error) {
    } else if (usersData && usersData["status"] === true) {
      console.log("usersData", usersData["data"]);
      setData(usersData["data"]);
    }
  }, [usersData, error]);

  useEffect(() => {
    if (usersWithIdError) {
    } else if (usersWithIdData && usersWithIdData["status"] === true) {
      console.log("usersWithIdData", usersWithIdData["data"]);
      setData(usersWithIdData["data"]);
    }
  }, [usersWithIdData, usersWithIdError]);

  //Create User
  useEffect(() => {
    if (createUsersError) {
    } else if (createUsersData && createUsersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: createUsersData["message"],
        status: createUsersData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (createUsersData && createUsersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createUsersData["message"],
        status: createUsersData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createUsersData, createUsersError]);

  //Update User
  useEffect(() => {
    if (updateUsersError) {
    } else if (updateUsersData && updateUsersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateUsersData["message"],
        status: updateUsersData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (updateUsersData && updateUsersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateUsersData["message"],
        status: updateUsersData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateUsersData, updateUsersError]);

  //Delete User
  useEffect(() => {
    if (deleteUsersError) {
    } else if (deleteUsersData && deleteUsersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteUsersData["message"],
        status: deleteUsersData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    } else if (deleteUsersData && deleteUsersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteUsersData["message"],
        status: deleteUsersData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    }
  }, [deleteUsersData, deleteUsersError]);

  //For Add the user
  const handleOpenCreateModal = () => {
    setEditMode(false);
    setOpenDialog(true);
    clearErrors();
    initializeUsers();
  };

  const handleMenuOpen = (event, userId) => {
    setAnchorEl(event.currentTarget);
    setSelectedUserId(userId);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleProfileImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      setUsers((prevData) => ({
        ...prevData,
        profile: URL.createObjectURL(file),
      }));
      setSelectedProfileFile(file);
    }
  };

  // Handle submit (create or update)
  const handleSubmit = () => {
    const mobileRegex = /^\d{10}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/i;
    const aadharRegex = /^\d{12}$/;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,20}$/;
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

     const validateField = (field, value, regex, errorSetter, errorMessage) => {
    const stringValue = value ? String(value).trim() : "";

    if (!stringValue) {
      errorSetter(errorMessage);
      return false;
    }

    if (regex && !regex.test(stringValue)) {
      errorSetter(errorMessage);
      return false;
    }
    errorSetter("");
    return true;
  };
    const validateAllFields = () => {
      clearErrors();
      if (
        !validateField(
          "firstName",
          users["firstName"],
          null,
          setFirstNameError,
          "First name is required."
        )
      )
        return false;
      if (
        !validateField(
          "mobileNo",
          users["mobileNo"],
          mobileRegex,
          setMobileNoError,
          "Please enter a valid 10-digit mobile number."
        )
      )
        return false;
      if (
        !validateField(
          "email",
          users["email"],
          emailRegex,
          setEmailError,
          "Please enter a valid email address."
        )
      )
        return false;
      if (
        !validateField(
          "role",
          users.role,
          null,
          setRoleError,
          "Role is required."
        )
      )
        return false;
      if (
        !validateField(
          "gender",
          users.gender,
          null,
          setGenderError,
          "Please select gender."
        )
      )
        return false;
      // if (!validateField("dob", users.dob, null, setDobError, "Date of birth is required.")) return false;
      if (
        !validateField(
          "aadharNo",
          users["aadharNo"],
          aadharRegex,
          setAadharNoError,
          "Aadhar number must be 12 digits."
        )
      )
        return false;
      if (
        !validateField(
          "panNo",
          users["panNo"],
          panRegex,
          setPanNoError,
          "Please enter a valid PAN number."
        )
      )
        return false;
      if (
        !validateField(
          "password",
          users["password"],
          passwordRegex,
          setPasswordError,
          "Password must be between 8-20 characters, include uppercase, lowercase, a number, and a special character."
        )
      )
        return false;

      if (!users.confirmPassword) {
        setConfirmPasswordError("Confirm password is required.");
        return false;
      }
      if (users["password"] !== users["confirmPassword"]) {
        setConfirmPasswordError("Passwords do not match.");
        return false;
      }

      return true;
    };

    const formdata = new FormData();
    if (validateAllFields()) {
      // If all validations pass, prepare the formdata for either create or update
      console.log("Validation Passed, Proceeding with formdata");

      formdata.append("first_name", users["firstName"]);
      formdata.append("last_name", users["lastName"]);
      formdata.append("mobile_number", users["mobileNo"]);
      formdata.append("email", users["email"]);
      formdata.append("password", users["confirmPassword"]);
      formdata.append("gender", users["gender"]);
      formdata.append("dob", users.dob ? convertDate(users.dob) : null);
      formdata.append("aadhar_number", users["aadharNo"]);
      formdata.append("pan_number", users["panNo"]);
      formdata.append(
        "profile",
        selectedProfileFile ? selectedProfileFile : users["profile"]
      );

      if (!isEditMode) {
        formdata.append("role_id", users["role"]);
        formdata.append("created_by", userDetails.user_id);
      }

      if (isEditMode) {
        // Edit Mode (Update user data)
        formdata.append("role_id", users["roleId"]);
        formdata.append(
          "status",
          users["status"] == "Active"
            ? 1
            : users["status"] == "Deactive"
            ? 0
            : ""
        );
        for (let [key, value] of formdata.entries()) {
          console.log("Form Data Contents:", `${key}: ${value}`);
        }
        const updateUrl = urls("updateUsers", users["userId"]);
        fetchUpdateData(updateUrl, formdata);
      } else if (!isEditMode) {
        // Create Mode (New user data)
        console.log("Form Data Contents:", convertDate(users.dob));
        for (let [key, value] of formdata.entries()) {
          console.log(`${key}: ${value}`);
        }
        fetchCreateData(formdata);
      }
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUserId(null);
  };

  //close button
  const handleClose = () => {
    setModalOpen(false);
    setDeleteModalOpen(false);
    clearErrors();
    if (createUsersData && createUsersData["status"] === true) {
      initializeUsers();
      setOpenDialog(false);
    }
    if (isEditMode) {
      if (updateUsersData && updateUsersData["status"] === true) {
        initializeUsers();
        setOpenDialog(false);
      }
    }
    setSnackbarState({
      message: "",
      status: "",
    });
  };

  // Handle delete
  const handleDelete = (userId) => {
    const deleteUrl = urls("deleteUsers", userId);
    setModalOpen(true);
    fetchDeleteData(deleteUrl);
  };

  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  // Filter data based on search
  const filteredData =
    data && data.length > 0
      ? data
          .sort((a, b) => b.user_id - a.user_id) // Sort by ID in descending order, latest ID first
          .filter(
            (item) =>
              (item.user_id &&
                item.user_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.first_name &&
                item.first_name.toLowerCase().includes(search.toLowerCase()))
          )
      : data;

  //Reset button
  const handleReset = () => {
    clearErrors();
    initializeUsers();
  };

  //Edit User
  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditMode(true);
    setOpenDialog(true);
    clearErrors();
    const genderChecked = {
      male: user["gender"] === "male",
      female: user["gender"] === "female",
    };

    setUsers({
      ...user,
      roleId: user["role_id"],
      userId: user["user_id"],
      firstName: user["first_name"],
      lastName: user["last_name"],
      mobileNo: user["mobile_number"],
      email: user["email"],
      role: user["role_id"],
      status:
        user["status"] == 1 ? "Active" : user["status"] == 0 ? "Deactive" : "",
      gender: user["gender"],
      dob: convertYearMonthDateToMonthDateYear(user["dob"]),
      aadharNo: user["aadhar_number"],
      panNo: user["pan_number"],
      profile: user["profile"],
      genderChecked,
    });
  };
  // Handle Gender checkbox
  const handleGenderChange = (e) => {
    const { name, checked } = e.target;
    setUsers((prevValues) => ({
      ...prevValues,
      gender: checked ? name : "",
    }));
  };

  //Date of birth selection
  const handleDateChange = (newValue) => {
    if (newValue) {
      console.log("date of birth:", newValue);
      setUsers({ ...users, dob: newValue });
    }
  };

  //Password
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setUsers({ ...users, password: newPassword });
  };
  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setUsers({ ...users, confirmPassword: newConfirmPassword });
  };
  const handlePasswordVisibilityToggle = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const handleConfirmPasswordVisibilityToggle = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  return (
    <Box
      sx={{
        bgcolor: "white",
        p: 2,
      }}
    >
      <Box
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            mt={2}
          >
            <TextField
              variant="outlined"
              placeholder="Search"
              size="small"
              value={search}
              onChange={handleSearch}
              sx={{
                width: "30%",
                backgroundColor: "#FFF",
                borderRadius: 1,
              }}
            />

            <Button
              variant="contained"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => handleOpenCreateModal()}
              sx={{ bgcolor: "#00796b", "&:hover": { bgcolor: "#005a4f" } }}
            >
              Add
            </Button>
          </Box>
          {/* Table Section */}
          <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table>
              <TableHead sx={{ backgroundColor: "#00796b" }}>
                <TableRow>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    User Id
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Name
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Email
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Phone
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Role
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Status
                  </TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <Typography>No records found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((user) => {
                      return (
                        <TableRow key={user.user_id}>
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Typography>{user.user_id}</Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Avatar sx={{ bgcolor: "#00796b", mr: 2 }}>
                                {user.first_name.charAt(0)}
                              </Avatar>
                              <Typography>{user.first_name}</Typography>
                            </Box>
                          </TableCell>
                          <TableCell>{user.email}</TableCell>
                          <TableCell>{user.mobile_number}</TableCell>
                          <TableCell>{user.role_name}</TableCell>
                          <TableCell>
                            {user.status == 1
                              ? "Active"
                              : user.status == 0
                              ? "Inactive"
                              : ""}
                          </TableCell>
                          <TableCell>
                            <IconButton
                              onClick={(e) => handleMenuOpen(e, user.user_id)}
                            >
                              <MoreVertIcon />
                            </IconButton>
                            <Menu
                              anchorEl={anchorEl}
                              open={
                                Boolean(anchorEl) &&
                                selectedUserId === user.user_id
                              }
                              onClose={handleMenuClose}
                            >
                              <MenuItem onClick={() => handleEdit(user)}>
                                Edit
                              </MenuItem>
                              <MenuItem
                                onClick={() => handleDelete(user.user_id)}
                              >
                                Delete
                              </MenuItem>
                            </Menu>
                          </TableCell>
                        </TableRow>
                      );
                    })
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data && data.length ? data.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </Box>
        <Dialog
          open={isDeleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
        >
          <DialogTitle>
            {snackbarState.status === true ? "Success" : "Error"}
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              sx={{
                color: snackbarState.status === true ? "green" : "red",
              }}
            >
              {snackbarState.message}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                alignSelf: "center",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog for Editing User */}
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          maxWidth="xl"
          fullWidth
        >
          <DialogTitle>
            {isEditMode ? "Edit User" : "Create User"}
            <IconButton
              aria-label="close"
              onClick={() => setOpenDialog(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {/* General information */}
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                padding: 2,
                maxWidth: 1200,
                margin: "auto",
                backgroundColor: "#fff",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                mt: 3,
              }}
            >
              <Typography variant="h6" sx={{ marginBottom: 2 }}>
                General information
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Fill an employee’s general info such as name, address number and
                set role
              </Typography>
              <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
                <Box sx={{ flex: 1 }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="First Name"
                    value={users.firstName}
                    error={!!firstNameError}
                    helperText={
                      firstNameError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {firstNameError}
                        </Typography>
                      )
                    }
                    onChange={(e) =>
                      setUsers({
                        ...users,
                        firstName: e.target.value,
                      })
                    }
                    sx={{ mb: 2 }}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="Last Name"
                    value={users.lastName}
                    onChange={(e) =>
                      setUsers({
                        ...users,
                        lastName: e.target.value,
                      })
                    }
                    sx={{ mb: 2 }}
                  />
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="Phone Number"
                    value={users.mobileNo}
                    error={!!mobileNoError}
                    helperText={
                      mobileNoError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {mobileNoError}
                        </Typography>
                      )
                    }
                    onChange={(e) =>
                      setUsers({ ...users, mobileNo: e.target.value })
                    }
                    sx={{ mb: 2 }}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="Email"
                    value={users.email}
                    error={!!emailError}
                    helperText={
                      emailError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {emailError}
                        </Typography>
                      )
                    }
                    onChange={(e) =>
                      setUsers({ ...users, email: e.target.value })
                    }
                    sx={{ mb: 2 }}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <Select
                      native
                      value={users.role || ""}
                      error={!!roleError}
                      onChange={(e) =>
                        setUsers({ ...users, role: e.target.value })
                      }
                    >
                      <option value="">Select Role</option>
                      {roleData.map((role) => (
                        <option key={role.role_id} value={role.role_id}>
                          {role.role_name}
                        </option>
                      ))}
                    </Select>

                    {roleError && (
                      <helperText>
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {roleError}
                        </Typography>
                      </helperText>
                    )}
                  </FormControl>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              ></Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                {isEditMode && (
                  <Box sx={{ flex: 1 }}>
                    <FormControl fullWidth>
                      <Typography sx={{}}>Status</Typography>
                      <Select
                        value={users?.status || ""}
                        onChange={(e) =>
                          setUsers({
                            ...users,
                            status: e.target.value,
                          })
                        }
                        displayEmpty
                        sx={{ height: "40px" }}
                      >
                        <MenuItem value="" disabled>
                          Status
                        </MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Deactive">Deactive</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                )}

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: "bold" }}>
                    Select Gender
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={users.gender === "male"}
                        onChange={handleGenderChange}
                        name="male"
                      />
                    }
                    label={<Typography variant="body2">Male</Typography>}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={users.gender === "female"}
                        onChange={handleGenderChange}
                        name="female"
                      />
                    }
                    label={<Typography variant="body2">Female</Typography>}
                  />
                  {genderError && (
                    <Typography
                      sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                    >
                      {genderError}
                    </Typography>
                  )}
                </Box>

                <Box sx={{ flex: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      label="Date of Birth"
                      value={users.dob ? new Date(users.dob) : null}
                      onChange={handleDateChange}
                      maxDate={new Date()}
                      error={!!dobError}
                      helperText={
                        dobError ? (
                          <Typography
                            sx={{
                              textAlign: "left",
                              marginTop: 1,
                              color: "red",
                            }}
                          >
                            {dobError}
                          </Typography>
                        ) : (
                          ""
                        )
                      }
                      renderInput={(params) => (
                        <TextField {...params} fullWidth sx={{ mb: 4 }} />
                      )}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="Aadhar Number"
                    value={users.aadharNo}
                    error={!!aadharNoError}
                    helperText={
                      aadharNoError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {aadharNoError}
                        </Typography>
                      )
                    }
                    onChange={(e) =>
                      setUsers({
                        ...users,
                        aadharNo: e.target.value,
                      })
                    }
                    sx={{ mb: 2 }}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="Pan Number"
                    value={users.panNo}
                    error={!!panNoError}
                    helperText={
                      panNoError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {panNoError}
                        </Typography>
                      )
                    }
                    onChange={(e) =>
                      setUsers({ ...users, panNo: e.target.value })
                    }
                    sx={{ mb: 2 }}
                  />
                </Box>
              </Box>

              <Typography>Upload Profile photo</Typography>
              <input
                type="file"
                accept="image/*"
                onChange={handleProfileImage}
              />
              {users.profile && (
                <Box
                  component="img"
                  src={users.profile}
                  sx={{
                    width: 300,
                    height: 300,
                    borderRadius: 1,
                    objectFit: "cover",
                    mt: 2,
                  }}
                  alt="Profile photo Preview"
                />
              )}
            </Box>
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                padding: 2,
                maxWidth: 1200,
                margin: "auto",
                backgroundColor: "#fff",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                mt: 3,
              }}
            >
              <Typography variant="h6" sx={{ marginBottom: 0 }}>
                Account Information
              </Typography>
              <Typography variant="body2" color="textSecondary">
                This info will need for employee's future login
              </Typography>
              <Box sx={{ flex: 1 }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="Email"
                  value={users.email}
                  onChange={(e) =>
                    setUsers({ ...users, email: e.target.value })
                  }
                  sx={{ mb: 2 }}
                />
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
               
                  <TextField
                    label="Password"
                    fullWidth
                    type={isPasswordVisible ? "text" : "password"}
                    value={users.password}
                    onChange={handlePasswordChange}
                    InputProps={{
                      endAdornment: (
                        <IconButton onClick={handlePasswordVisibilityToggle}>
                          {isPasswordVisible ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      ),
                    }}
                    error={!!passwordError}
                    helperText={
                      passwordError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {passwordError}
                        </Typography>
                      )
                    }
                    variant="outlined"
                  />
               
               
                  <TextField
                    label="Confirm Password"
                    fullWidth
                    type={isConfirmPasswordVisible ? "text" : "password"}
                    value={users.confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          onClick={handleConfirmPasswordVisibilityToggle}
                        >
                          {isConfirmPasswordVisible ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      ),
                    }}
                    error={!!confirmPasswordError}
                    helperText={
                      confirmPasswordError && (
                        <Typography
                          sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                        >
                          {confirmPasswordError}
                        </Typography>
                      )
                    }
                    variant="outlined"
                  />
                
              </Box>
              <DialogActions>
                {!isEditMode && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleReset}
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                    }}
                  >
                    Reset
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleSubmit}
                  sx={{
                    textTransform: "none",
                    borderRadius: 2,
                  }}
                >
                  Submit
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
          <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
            <DialogTitle>
              {snackbarState.status === true ? "Success" : "Error"}
            </DialogTitle>
            <DialogContent>
              <Typography
                variant="body1"
                sx={{
                  color: snackbarState.status === true ? "green" : "red",
                }}
              >
                {snackbarState.message}
              </Typography>
            </DialogContent>
            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleClose}
                sx={{
                  textTransform: "none",
                  borderRadius: 2,
                  alignSelf: "center",
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Dialog>
      </Box>
    </Box>
  );
}
